import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import Phone from './Phone'
import DatePickers from './DatePicker'
import Time from './Time'
import SingleChoice from './SingleChoice'
import LongText from './LongText'

const FashionPhotographyIntakeForm = () => {


    const fashionPhotographyData = [
        {
            id: 1,
            label: "ادیتوریال (سبک مجله‌ای)",
            checked: false
        },
        {
            id: 2,
            label: "ران‌وی (صحنه نمایش)",
            checked: false
        },
        {
            id: 3,
            label: "بدون گلوتن",
            checked: false
        },
        {
            id: 4,
            label: "لوک‌بوک (کتابچه محصول)",
            checked: false
        },
        {
            id: 5,
            label: "کاتالوگ (فهرست محصول)",
            checked: false
        },
        {
            id: 6,
            label: "استریت استایل (سبک خیابانی)",
            checked: false
        },
        {
            id: 7,
            label: "سایر",
            checked: false
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم پذیرش عکاسی مد'} subHeader={'لطفا جزئیات زیر را برای کمک به ما در آماده‌سازی جلسه عکاسی مد خود ارائه دهید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'آدرس ایمیل'} />
                <Phone header={'شماره تلفن'} />
                <DatePickers header={'تاریخ مورد نظر برای عکاسی'}/>
                <Time header={'زمان پیشنهادی برای عکاسی'}/>
                <SingleChoice header={'نوع عکاسی مد'} options={fashionPhotographyData}/>
                <LongText header={'دیدگاه یا تم خود را برای عکاسی شرح دهید'}/>
                <LongText header={'آیا مکان‌های خاصی را مد نظر دارید؟'}/>
                <LongText header={'آیا سبک خاصی از لباس‌ها وجود دارد که بخواهید برجسته کنید؟'}/>
                <LongText header={'یادداشت‌ها یا درخواست‌های اضافی'}/>
            </Grid>
        </Grid>
    )
}

export default FashionPhotographyIntakeForm
